import { gql } from '@apollo/client'
import React from 'react'

import { fieldsClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Fields($origin: [String], $type: [String], $search: String, $page: Int, $limit: Int) {
    fields(
      filter: { origins: $origin, types: $type }
      search: $search
      page: $page
      limit: $limit
      sort: { field: ORIGIN, type: ASC }
    ) {
      id
      name
      origin
      type
      placeType {
        id
        key
        name
        namePlural
      }
    }
  }
`

export const useFieldValuesLoader = (origin, type) => {
  const query = usePromiseQuery(QUERY, { client: fieldsClient })
  return (search, page = 1, limit = 100) => {
    return query({ origin, type, search, page, limit })?.then(response => {
      return response.data.fields.map(field => ({
        id: field.id,
        name: field.name,
        type: field.type,
        origin: field.origin,
        group: field.placeType?.namePlural
      }))
    })
  }
}

const FieldValueSelect = ({ onChange, onOptionsChange, value, origin, type, disableItem, ...props }) => {
  const getOptions = useFieldValuesLoader(origin, type)

  return (
    <Select
      value={value}
      onChange={onChange}
      options={getOptions}
      descriptionField="field.name"
      disableItem={disableItem}
      {...props}
    />
  )
}

export default FieldValueSelect
